export const examAdminAssetsCenter = {
  pageTitle: "アセット",
  pageSubtitle:
    "アップロード済みアセットを一元管理し、ダウンロード、参照保護付き削除、一括運用に対応します。",
  scopeGlobal: "対象範囲：全体アセット（管理者）",
  scopeMine: "対象範囲：自分のアセット領域（{username}）",
  searchFilenamePlaceholder: "ファイル名/オブジェクトキーで検索",
  searchContentTypePlaceholder: "コンテンツタイプで検索",
  createAction: "アセットをアップロード",
  batchDeleteAction: "一括削除",
  summaryTotal: "総アセット数：{count}",
  summarySelected: "選択中のアセット：{count}",
  table: {
    filename: "ファイル名",
    contentType: "種別",
    sizeBytes: "サイズ（バイト）",
    referenceStatus: "参照状態",
    uploadedAt: "アップロード日時",
  },
  labels: {
    inUse: "参照中（{count}）",
    notInUse: "未参照",
  },
  messages: {
    uploadSuccess: "アセットをアップロードしました",
    deleteSuccess: "アセットを削除しました",
    deleteBlocked: "アセットは参照中のため削除できません（{labels}）",
    selectFileWarning: "先にファイルを選択してください",
  },
  confirm: {
    deleteTitle: "このアセットを削除しますか？",
    deleteDescription: "削除前に参照状態を確認します。",
    batchDeleteTitle: "選択したアセットを一括削除しますか？",
    batchDeleteDescription:
      "システムは参照状態を 1 件ずつ確認し、参照中のアセットは自動でスキップして通知します。",
    batchDeleteOkText: "削除を確定",
  },
  drawer: {
    uploadTitle: "アセットをアップロード",
    sceneLabel: "シーン識別子（任意）",
    scenePlaceholder: "例：exam_attachment / question_material",
  },
};
